import { render, staticRenderFns } from "./OrderSets.vue?vue&type=template&id=35cc0e0c&scoped=true"
import script from "@/views/Webshop/OrderSets/OrderSets.ts?vue&type=script&lang=ts&external"
export * from "@/views/Webshop/OrderSets/OrderSets.ts?vue&type=script&lang=ts&external"
import style0 from "@/views/Webshop/OrderSets/order-sets.scss?vue&type=style&index=0&id=35cc0e0c&prod&lang=scss&scoped=true&external"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "35cc0e0c",
  null
  
)

export default component.exports